import { TagApi } from '@movilizame/networking';

export class CompanyApi {

    constructor (net, list) {
        this.net = new TagApi(net, list);
    }

    index () {
        return this.net.get('/api/empresa');
    }

    terms (lang) {
        return this.net.get('/api/terminos' + (lang ? ('?lang=' + lang) : ''));
    }

    /**
     * Estimación de tarifa (servidor). Sin autenticación.
     */
    estimateTariff (data) {
        return this.net.post('/api/public/tarifa-estimada', data);
    }

}



// WEBPACK FOOTER //
// ./src/services/api/Company.js